import React from "react";

const TitleRockSvg = () => (
  <svg
    width="161"
    height="35"
    viewBox="0 0 161 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      d="M0.320312 27.7093V20.1733L7.47231 18.9733V0.73325H57.3443V18.1093L20.0003 24.3973V34.3333H7.47231V26.5093L0.320312 27.7093ZM20.0003 16.8613L44.8163 12.6853V7.54925H20.0003V16.8613ZM64.5466 34.3333V8.89325H107.987V34.3333H64.5466ZM76.5466 28.0933H95.9866V15.1333H76.5466V28.0933ZM112.305 30.2053V22.8133L118.305 21.4213V8.89325H130.305V18.7333L148.305 14.6533V8.89325H160.305V19.2133L146.145 22.3813L152.865 28.0933H160.305V34.3333H146.145L135.345 24.7333L130.305 25.9333V34.3333H118.305V28.8133L112.305 30.2053Z"
      fill="white"
    />
  </svg>
);

export default TitleRockSvg;
